export default "__VITE_ASSET__2c7a9596__"